import * as State from './state'
import * as Utils from './utils'

export const $status = {
  ...State.GLOBAL_STATUS
}

export const $enum = {
 ...State.GLOBAL_ENUM
}

export const $config = {
 ...State.GLOBAL_CONFIG
}

export const $utils = {
 ...Utils
}

export const $tips = {
 ...State.GLOBAL_TIPS
}
